import { Component } from '@angular/core';
import { Subscription } from "rxjs/Subscription";
import { LocalStorageService } from "angular-2-local-storage";
import { JiraResult } from './jira-result';
import { Column } from '../admin/column';
import { SearchTableState } from '../admin/search-table-state';
import { PageStateService } from '../admin/page-state.service';
import { BaseTableComponent } from '../admin/base-table.component';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { JiraDashboardService } from './jira-dashboard.service';

@Component({
    selector: 'jira-table',
    template: require('./jira-table.html'),
    providers: [LocalStorageService, JiraDashboardService],
    styles: [require('../admin/table.css')]
})

export class JiraTableComponent extends BaseTableComponent {

    private issues = new Array<JiraResult>();
    private columns: Array<Column>;
    private busy: Subscription;
    private queryParamsSub: any;
    private static lastRefreshed: string = 'issue-last-refreshed';

    constructor(
        private pageStateService: PageStateService,
        private localStorageService: LocalStorageService,
        private http: HttpClient,
        private jiraDashboardService:JiraDashboardService
    ) {
        super(localStorageService);
        this.setColumns();
    }

    public goTo(value: number): void {
        if (value <= this.baseSearchTableState.pageCount()) {
            this.baseSearchTableState.pageChange(value);
            this.updateTable();
        }
    }

    ngOnInit() {
        this.baseSearchTableState.currentPage = this.pageStateService.currentIssuePage;
        this.setPageSize('issue-page-size');
        this.blankPage();
        this.setLastRefreshed(JiraTableComponent.lastRefreshed);
        this.updateTable();
    }

    ngOnDestroy() {
        this.pageStateService.currentUserPage = this.baseSearchTableState.currentPage;
        this.queryParamsSub.unsubscribe();
    }

    private setColumns() {
        this.columns = new Array<Column>();
        this.columns.push(new Column('Created', 'Created'));
        this.columns.push(new Column('Key', 'Key'));
        this.columns.push(new Column('Reporter', 'Reporter'));
        this.columns.push(new Column('Assignee', 'Assignee'));
        this.columns.push(new Column('Status', 'Status'));
        this.columns.push(new Column('Summary', 'Summary'));
    }

    private blankPage() {
        this.issues = new Array<JiraResult>();
        for (let i: number = 0; i < this.baseSearchTableState.itemsPerPage; i++) {
            this.issues.push(new JiraResult());
        }
    }

    private updateTable(): void {
        if (this.baseSearchTableState.updating) {
            return;
        }
        this.baseSearchTableState.updating = true;
        let self: JiraTableComponent = this;
        this.busy = this.search().subscribe((message: Array<JiraResult>) => {
            self.baseSearchTableState.updating = false;
            self.issues = message;
        }, error => self.baseSearchTableState.updating = false);
    }

    private search(): Observable<Array<JiraResult>> {
        let copy: any = Object.assign({}, this.baseSearchTableState);
        copy.ProjectNames = this.jiraDashboardService.projectNames;
        copy.DaysBack = -1;
        return this.http.post<Array<JiraResult>>(this.jiraDashboardService.url, copy).map(data => {
            this.baseSearchTableState.totalItems = data.length ? data[0].total : 0;
            return data;
        });
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/jira-table.component.ts